import React, { Component } from 'react'
import { AppBar, Box, Button, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
//import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { Link } from "react-router-dom";
import Slide from '@material-ui/core/Slide';
import './../App.css'
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    }
  }));

  const newS = {
    aboutLink : {
      marginRight : 1000
    }
  }

  function HideOnScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({ target: window ? window() : undefined });
  
    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children}
      </Slide>
    );
  }
  
  HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  };
  
class Header extends Component {
  
  
    
    render() {
      
        return (
            <React.Fragment>
                <HideOnScroll >
                    <AppBar style={{backgroundColor : '#379683'}}>
                    <Toolbar variant="regular">
                        <Box flexGrow={1}>
                            <Typography variant="body1">
                                <div style={{flexGrow: 1,}}>
                                    {this.props.name}
                                </div>
                            </Typography>
                        </Box>
                        <div onClick={this.props.linkToAbout}>
                          <Typography  style={newS} className="link">
                            {this.props.aboutMe ? '01.About Me' : ''}
                          </Typography>
                        </div>
                        <div style={{width : '10px'}}></div>
                        <div onClick={this.props.linkToProjects} class="link" id="project-link">
                          <Typography>
                            {this.props.aboutMe ? '02.My Projects' : 'My Projects'}
                          </Typography>
                        </div>
                        {/* <Typography>
                          {
                            this.props.aboutMe? 
                            '01.About Me  02.My Projects' : 'My Projects'
                          }
                        </Typography> */}
                    </Toolbar>
                </AppBar>
                </HideOnScroll>
                
            </React.Fragment>
        )
    }
}

export default Header
